import { render, staticRenderFns } from "./ClaimsSummary.vue?vue&type=template&id=6705ef0a&scoped=true&"
import script from "./ClaimsSummary.vue?vue&type=script&lang=js&"
export * from "./ClaimsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsSummary.vue?vue&type=style&index=0&id=6705ef0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705ef0a",
  null
  
)

export default component.exports